/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Wed Sep 28 2022
*  File : LoginEvaluationConverter.ts
*******************************************/

import { isSubmitLogin, SubmitLogin } from "@api-commons/cta/EvaluatedAction.js";
import { CTA_NAME, CTA_OUTCOME, CTAStatsDetails } from "@api-commons/stats/CTATypes.js";
import { EvaluationConverter } from "../EvaluationConverter.js";

export class LoginEvaluationConverter implements EvaluationConverter {
    public check = isSubmitLogin;
    
    public convert(action: SubmitLogin): CTAStatsDetails {
        if (action.data.providerId && action.data.providerId.length > 0) {
            if (action.data.providerId.length > 1) {
                return {
                    outcome: CTA_OUTCOME.SHOWN,
                    action: CTA_NAME.LOGIN_MULTI,
                    source_element: "evaluation"
                };
            }
            else {
                const prov = action.data.providerId[0];
                return {
                    outcome: CTA_OUTCOME.SHOWN,
                    action: CTA_NAME.LOGIN,
                    source_element: "evaluation",
                    provider: prov
                };
            }
        }
        else {
            throw new Error("Unexpected evaluation. Got a 'SubmitLogin' evaluation withoud provider ids");
        }

    }
}